import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  showLoading(event) {
    const button = this.buttonTarget

    button.classList.add("loading")

    const originalContent = button.innerHTML
    button.dataset.originalContent = originalContent

    const spinner = document.createElement("span")
    spinner.className = "fas fa-spinner fa-spin mr-2"
    button.prepend(spinner)

    // Disable after a small delay to allow form submission
    setTimeout(() => {
      button.disabled = true
    }, 10)
  }

  hideLoading() {
    const button = this.buttonTarget

    button.disabled = false
    button.classList.remove("loading")

    if (button.dataset.originalContent) {
      button.innerHTML = button.dataset.originalContent
    }
  }
}
